import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useLanguageOptions = () => {
    const { t, i18n } = useTranslation()

    const languages = useMemo(() => [
        { id: 'ko', label: t('V3.language.ko') },
        { id: 'en', label: t('V3.language.en') },
        { id: 'ja', label: t('V3.language.ja') },
        { id: 'cn', label: t('V3.language.cn') }
    ], [t])
    const current = languages.find((language) => language.id === i18n.resolvedLanguage) ?? languages[0]

    return {
        languages,
        current,
        changeLanguage: (id: string) => i18n.changeLanguage(id)
    }
}
